import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  message,
  Divider,
  Table,
  Modal,
  Typography,
  Space,
  Button,
  Alert,
  Dropdown,
  Tag,
  Tabs,
} from "antd";
import { FileDoneOutlined, DownloadOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const AvaliacoesResultadosDetalhes = () => {
  const { id_colaborador, id_avaliacao } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [modal, contextHolder] = Modal.useModal();

  useEffect(() => {
    if (id_colaborador > 0 && id_avaliacao > 0) {
      carregarAvaliacaoResultado(id_colaborador, id_avaliacao);
    }
  }, [id_colaborador, id_avaliacao]);

  // LISTAR
  const carregarAvaliacaoResultado = async (idColaborador, idAvaliacao) => {
    if (!idColaborador || !idAvaliacao) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios_lancamento/carregar_resultado`, {
      id_colaborador: idColaborador,
      id_avaliacao: idAvaliacao,
    });
    if (api.statusCode === 200) {
      if (!api?.response?.data?.id) {
        navigate("/avaliacoes/resultados");
      }
      setDados(api?.response?.data);
    } else {
      navigate("/avaliacoes/resultados");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // GERAR PDI
  const gerarPdi = async (idColaborador, idAvaliacao) => {
    if (!idColaborador || !idAvaliacao) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_formularios_lancamento/gerar_pdi`, {
      id_colaborador: idColaborador,
      id_avaliacao: idAvaliacao,
    });

    if (api.statusCode === 200) {
      message.success("PDI gerado com sucesso!");
      carregarAvaliacaoResultado(id_colaborador, id_avaliacao);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // BAIXAR AVALIAÇÃO
  const gerarRelatorio = async (idColaborador, idAvaliacao, tipo) => {
    if (!idColaborador || !idAvaliacao) return;
    setLoading(true);
    const api = await http(
      "file",
      `v1/avaliacoes_formularios_lancamento/gerar_relatorio?id_colaborador=${idColaborador}&id_avaliacao=${idAvaliacao}&tipo=${tipo}`,
      []
    );

    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "relatorio.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns_descritivas = [
    {
      dataIndex: "descricao",
      title: "Descrição",
    },
  ];

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Descrição",
    },

    {
      key: "total_autoavaliacao",
      title: "Autoavaliação",
      width: 80,
      render: (_, e) => e.total_autoavaliacao,
    },
    {
      key: "total_grupo",
      title: "Grupo",
      width: 80,
      render: (_, e) => e.total_grupo,
    },
  ];

  const rowClassName = (record) => {
    if (record.children) {
      return "parent-row";
    }
    return "";
  };

  const items = [
    {
      label: "Completo",
      key: "1",
      onClick: () => gerarRelatorio(id_colaborador, id_avaliacao, 1),
    },
    {
      label: "Simplificado",
      key: "2",
      onClick: () => gerarRelatorio(id_colaborador, id_avaliacao, 2),
    },
    {
      label: "Completo Detalhado",
      key: "3",
      onClick: () => gerarRelatorio(id_colaborador, id_avaliacao, 3),
    },
  ];

  const renderFooter = () => {
    return (
      <React.Fragment>
        <Table.Summary.Row style={{ backgroundColor: "#f7f7f7" }}>
          <Table.Summary.Cell index={0}>
            <Text strong>Total</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={1}>
            <Text strong>{dados?.total_autoavaliacao}</Text>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={2}>
            <Text strong>{dados?.total_grupo}</Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>

        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={3} index={0}>
            <Text strong>Índice das Competências: {dados?.indice}</Text>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </React.Fragment>
    );
  };

  const items_tabs = [
    {
      key: "1",
      label: "Objetivas",
      children: (
        <Table
          loading={loading}
          scroll={{ x: 700 }}
          columns={columns}
          dataSource={dados?.grupos}
          size="small"
          rowKey="id"
          expandRowByClick
          rowClassName={rowClassName}
          summary={renderFooter}
          pagination={false}
        />
      ),
    },
    {
      key: "2",
      label: "Descritivas",
      children: (
        <Table
          loading={loading}
          scroll={{ x: 700 }}
          columns={columns_descritivas}
          dataSource={dados?.grupos_descritivas}
          size="small"
          rowKey="id"
          expandRowByClick
          pagination={false}
          expandable={{
            expandedRowRender: (e) =>
              e?.questoes?.map((quest) => (
                <Space key={quest?.id} direction="vertical">
                  <Text strong>{quest?.descricao}</Text>
                  <Space wrap align="start">
                    {quest?.respostas?.map((e) => (
                      <Card
                        key={e?.id}
                        style={{ borderStyle: "dashed", borderWidth: 2, width: "100%", maxWidth: 450 }}
                        bodyStyle={{ padding: 15 }}>
                        <Space direction="vertical" className="line-break">
                          {e.resposta}
                          {e?.autoavaliacao === 1 && <Tag color="green">Autoavaliação</Tag>}
                        </Space>
                      </Card>
                    ))}
                  </Space>
                </Space>
              )),
            rowExpandable: (record) => record.name !== "Not Expandable",
          }}
          rowClassName={rowClassName}
        />
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes/resultados")} />
            <HeaderTitle
              title="Avaliações Resultado Detalhes"
              subtitle="Resultado da avaliação"
              icon={<FileDoneOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Row>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      Avaliação
                    </Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {dados?.avaliacao}
                    </Text>
                  </Space>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      Ano
                    </Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {dados?.ano}
                    </Text>
                  </Space>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                  <Space direction="vertical" size={0}>
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      Colaborador Avaliado
                    </Text>
                    <Text strong style={{ fontSize: 16 }}>
                      {dados?.colaborador}
                    </Text>
                  </Space>
                </Col>
              </Row>

              <Tabs defaultActiveKey="1" items={items_tabs} />
              <br />
              <Space wrap>
                {dados?.total_baixas > 0 && dados?.status_pdi === 0 && (
                  <Button
                    type="primary"
                    loading={loading}
                    onClick={() =>
                      modal.confirm({
                        title: "Deseja gerar o PDI para este colaborador?",
                        content: (
                          <Alert
                            message="Será criado o PDI referênte aos grupos que possuirem pontuação menor que 3!"
                            type="info"
                            showIcon
                          />
                        ),
                        okText: "Sim",
                        cancelText: "Cancelar",
                        onOk() {
                          gerarPdi(id_colaborador, id_avaliacao);
                        },
                      })
                    }>
                    Gerar PDI
                  </Button>
                )}
                <Dropdown
                  menu={{
                    items,
                  }}
                  trigger={["click"]}>
                  <Button icon={<DownloadOutlined />} loading={loading}>
                    Download
                  </Button>
                </Dropdown>
              </Space>
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
